function searchToggle(obj, evt){
    if ($(window).width() < 769){
        var container = $(obj).closest('.search-wrapper');
        if(!container.hasClass('active')){
            container.addClass('active');
            $('.games__menu__toggler').fadeOut();
            evt.preventDefault();
        }
        else if(container.hasClass('active') && $(obj).closest('.input-holder').length == 0){
            container.removeClass('active');
            $('.games__menu__toggler').fadeIn();
            // clear input
            container.find('.search-input').val('');
        }
    }
}

$(document).ready(function () {
    var nHelper = $(".helper"),
        nExpand = $("[data-expand]"),
        WIN = $(window),
        DOC = $(document),
        scrollTo = null,
        isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
        isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);
    var mainSlider = new Swiper ('[data-slider-main]', {
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });

    var winnersSlider = new Swiper ('[data-slider-winners]', {
        loop: true,
        freeMode: true,
        queueEndCallbacks: true,
        slidesPerView: 'auto',
        momentumRatio: 2,
        freeModeFluid: true,
        noSwiping: true,
        autoplayDisableOnInteraction: false,
        speed: 3000,
        autoplay: {
            delay: 0,
        },
        freeModeMomentum: true,
        mousewheelSensitivity: 0.02,
        simulateTouch: true
    });


    function checkPreloader(){
        $('.preloader').fadeOut('slow', function(){
            $(this).remove();
        });
    }
    checkPreloader();
    setTimeout(function(){
        checkPreloader();
    }, 10000);

    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.scroll-to-top').fadeIn();
        } else {
            $('.scroll-to-top').fadeOut();
        }
    });

    setInterval(function(){
        $('main').toggleClass("blink");
    }, 500);


    $('[data-mob-left]').click(function(e){
        e.preventDefault();
        $(this).toggleClass('open');
        $('.mobile__nav--left').fadeToggle();
        $('.helper').toggleClass('left');
        $('body').toggleClass('disabled');
    });

    // $('[data-mob-right]').click(function(e){
    //     e.preventDefault();
    //     $(this).toggleClass('open');
    //     $('.mobile__nav--right').fadeToggle();
    //     $('.helper').toggleClass('right');
    //     $('body').toggleClass('disabled');
    // });

    $(window).on("orientationchange", function(e) {
        if ($(window).width() < 1024) {
            if ($('[data-mob-left]').hasClass('open'))  {
                $('[data-mob-left]').click();
            }
            // if ($('[data-mob-right]').hasClass('open'))  {
            //     $('[data-mob-right]').click();
            // }
        }
        if ($('[data-menumobile]').hasClass('opened')) {
            $('[data-menumobile]').click();
        }

    });



    $('.scroll-to-top').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop : 0}, 800);
    });


    /*Mobile tables*/
    (function () {
        var headertext = [];
        var headers = document.querySelectorAll("thead");
        var tablebody = document.querySelectorAll("tbody");

        for (var i = 0; i < headers.length; i++) {
            headertext[i] = [];
            for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
                var current = headrow;
                headertext[i].push(current.textContent.replace(/\r?\n|\r/, ""));
            }
        }

        if (headers.length > 0) {
            for (var h = 0, tbody; tbody = tablebody[h]; h++) {
                for (var i = 0, row; row = tbody.rows[i]; i++) {
                    for (var j = 0, col; col = row.cells[j]; j++) {
                        col.setAttribute("data-label", headertext[h][j]);
                    }
                }
            }
        }
    }());



    function preventScroll() {
        $("body").bind('mousewheel DOMMouseScroll touchmove', function (event) {

            if (event.type == 'mousewheel') {
                scrollTo = (event.originalEvent.wheelDelta * -1);
            }

            else if (event.type == 'DOMMouseScroll') {
                scrollTo = 40 * event.originalEvent.detail;
            }

            if (scrollTo) {
                event.preventDefault();
                $(this).scrollTop(scrollTo + $(this).scrollTop());
            }

            return false;
        });
    }




    $('.editable-box iframe').each(function (){
        $(this).wrap('<div class="videowrapper">');
    });


    $('[data-expand]').click(function () {
        $('[data-games-group]').toggleClass('visible');
        $(this).toggleClass("opened");
    });

    $('[data-submenu]').click(function () {
        $('[data-submenu-group]').toggleClass('visible');
        $(this).toggleClass("opened");
    });


    $('[data-menumobile]').click(function () {
        $('[data-games-list]').fadeToggle(200);
        $(this).toggleClass("opened");
    });


    var firstOpen = true;

    $('[data-modal]').magnificPopup({
        type: 'ajax',
        removalDelay: 100,
        mainClass: 'mfp-fade',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                firstOpen = true;
                $('body').removeClass('blur');
            }
        }
    });

    /** Language select **/
    DOC.on('click', '.lang-select', function() {
        $(this).toggleClass('open');
    });
    $(".lang-select .lang-select__item").click(function() {
        $(this).siblings(".lang-select__item").removeClass('active');
        $(this).toggleClass('active')
    });

    /** Закрытие списка языков при клике вне его **/
    DOC.on('click', function(e) {
        if (!$(e.target).closest(".lang").length) {
            $('.lang-select').removeClass('open');
        }
        e.stopPropagation();
    });
    /** End **/



    /* sound button */
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    var globalBgSound = getCookie("backSound") === "1" || getCookie("backSound") === null;
    // recall sound settings from cookies
    if (globalBgSound) {
        $('#audio-player').attr('autoplay', 'autoplay');
    } else {
        $('.btn-sound').addClass("off");
    }

    function turnBgSoundOn() {
        globalBgSound = 1;
        $("#audio-player")[0].play();
        document.cookie = 'backSound=1;path=/';
    }

    function turnBgSoundOff() {
        globalBgSound = 0;
        var audioPLayer = $('#audio-player')[0];
        audioPLayer.pause();
        audioPLayer.currentTime = 0;
        document.cookie = 'backSound=0;path=/';
    }
    $('.btn-sound').click( // todo mobile switch
        function () {
            if (globalBgSound) {
                turnBgSoundOff();
                $('.btn-sound').addClass("off");

            } else {
                turnBgSoundOn();
                $('.btn-sound').removeClass("off");

            }
        }
    );
    /* end sound button */


    /* caret */
    var lastFocusedInput = $("input[type='text']:eq(0)");

    DOC.on("focus", "input[type='text'], input[type='password']", function () {
        lastFocusedInput = $(this);
    });
    function buttonClick(target) {
        if (!lastFocusedInput) {
            return;

        }

        if(firstOpen) {
            lastFocusedInput = $("#btn-login input[type=text]");
            firstOpen = false
        }

        var value = target.text();
        var caretPos = lastFocusedInput.caret();

        if (value == "C") {
            lastFocusedInput.val("");
        } else if (value == "<") {
            lastFocusedInput.range(caretPos - 1, caretPos).range("").val();
        } else {
            lastFocusedInput.caret(caretPos).caret(value);
        }
        lastFocusedInput.focus().change();
    }

    DOC.on("click", ".keyboard a", function (e) {
        e.preventDefault();
        buttonClick($(this));
    });

    if (isMacLike) {
        $("html").addClass("apple");
    }
    if (isIOS) {
        $("html").addClass("ios");
    }
    var ua = window.navigator.userAgent;
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        $("html").addClass("edge");
    }
    if(ua.indexOf('Trident/7.0') + 1){
        $("html").addClass("ie");
    }

    if (/Android/i.test(navigator.userAgent)) {
        $("html").addClass("android");
    }
});
